"use client";
import { css as e } from "@emotion/react";
const s = (r, t) => e`
	border-radius: ${t};
	height: ${r};
	width: ${r};
`;
export {
  s as square
};
